import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/personApplications/history/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/personApplications/history/detail',
    method: 'get',
    params: data,
  })
}
// 撤销审核(人员预约申请记录)
export async function revokeForHis(data) {
  return request({
    url: '/personApplications/revokeForHis',
    method: 'post',
    data,
  })
}
// 撤销审核(人员预约信息管理)
export async function revokeForAllHis(data) {
  return request({
    url: '/personApplications/revokeForAllHis',
    method: 'post',
    data,
  })
}